import { useState } from "react";
import {
  Box,
  Drawer,
  Hidden,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Menu as MenuIcon } from "@mui/icons-material";

import UploadTargetsBtn from "components/shared/UploadTargetsBtn";
import LeftContent from "components/wrappers/LeftContent";
import useCatalogDetail from "hooks/useCatalogDetail";
import { Workflow } from "types/design";

import { FusionPartnerCollapse } from "./FusionPartnerCollapse";
import { NeedHelp } from "./NeedHelp";

export const Sidebar = () => {
  const [visibleSidebar, setVisibleSidebar] = useState<boolean>(false);
  const { workflow } = useCatalogDetail();
  const classes = useStyles();

  return (
    <Box component="section">
      <Hidden mdUp>
        <LeftContent>
          <Toolbar variant="dense" disableGutters>
            <Box
              width={1}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <IconButton
                edge="start"
                color="primary"
                className={classes.hamburgerMenu}
                onClick={() =>
                  setVisibleSidebar((visibleSidebar) => !visibleSidebar)
                }
                size="large">
                <MenuIcon />
              </IconButton>
              <UploadTargetsBtn />
            </Box>
          </Toolbar>
          <Drawer
            open={visibleSidebar}
            PaperProps={{ className: classes.sidebarDrawer }}
            onClose={() => setVisibleSidebar(false)}
          >
            <Box
              paddingX={3}
              paddingY={2}
              display="flex"
              flexDirection="column"
              gap="24px"
            >
              {workflow?.name === Workflow.FUSION && <FusionPartnerCollapse />}
              <NeedHelp />
            </Box>
          </Drawer>
        </LeftContent>
      </Hidden>
      <Hidden mdDown>
        <LeftContent>
          <Typography component="h2" variant="body1">
            Didn't see what you want? You can try again.
          </Typography>
          <Box mt={2} display="flex" flexDirection="column" gap="24px">
            <UploadTargetsBtn fullWidth />
            {workflow?.name === Workflow.FUSION && <FusionPartnerCollapse />}
            <NeedHelp />
          </Box>
        </LeftContent>
      </Hidden>
    </Box>
  );
};

const useStyles = makeStyles({
  sidebarMenuItem: {
    "& > .MuiTypography-root": {
      fontWeight: 600,
      textTransform: "uppercase",
    },
  },
  hamburgerMenu: {
    marginRight: 6,
  },
  sidebarDrawer: {
    width: 328,
    boxShadow: "none",
  },
});
